import { useState } from 'react';

/**
 * Custom hook for managing task detail modal state
 * @returns {Object} { activeTask, open, close }
 */
function useTaskDetailModal() {
  const [activeTask, setActiveTask] = useState(null);

  const open = (boardTaskId, boardId, taskDbId) => {
    setActiveTask({ boardTaskId, boardId, taskDbId });
  };

  const close = () => {
    setActiveTask(null);
  };

  return { activeTask, open, close };
}

export default useTaskDetailModal;
